/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import CheckBox from "../../../../../shared-ui/checkbox";
// import "react-accessible-accordion/dist/fancy-example.css";

interface LongSuveryRankingComponentProps {
  questionType: string;
  questionValue: string;
  questionTitle: string;
  optionList: any;
  optionsListWithAnswer: any;
  disableAllAnswers: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState?: any
  ) => void;
}

interface LongSuveryRankingComponentState {
  listOfOptions: any;
  selectedValues: any;
  optionsListWithAnswer: string;
}
class LongSuveryRankingComponent extends React.Component<
  LongSuveryRankingComponentProps,
  LongSuveryRankingComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      listOfOptions: [],
      selectedValues: [],
      optionsListWithAnswer: "",
    };
  }

  componentDidMount = () => {
    const { optionList, optionsListWithAnswer } = this.props;

    let data = optionList;
    data.forEach(function (item: {
      isChecked: boolean;
      isDisabled: boolean;
      isMandatory: boolean;
      id: string;
    }) {
      if (item.id === "everyday-health") {
        item.isMandatory = true;
        // item.isChecked=true
      } else {
        item.isChecked = false;
        item.isDisabled = false;
      }
    });
    if (optionsListWithAnswer !== undefined) {
      data.forEach((element: any) => {
        if (
          _.find(optionsListWithAnswer, (obj) => obj.id === element?.id) !==
          undefined &&
          element?.id !== "everyday-health"
        ) {
          element.isChecked = true;
          // element.isDisabled=false
        } else {
          if (optionsListWithAnswer.length === 4) {
            element.isDisabled = true;
          }
        }
      });
      this.setState({
        listOfOptions: data,
        selectedValues: optionsListWithAnswer,
      });
    } else {
      this.setState({
        listOfOptions: data,
      });
    }
  };

  componentDidUpdate = () => {
    if (
      this.props.optionsListWithAnswer !== undefined &&
      this.state.optionsListWithAnswer !== this.props.optionsListWithAnswer
    ) {
      this.setState({
        optionsListWithAnswer: this.props.optionsListWithAnswer,
      });
      const { optionList, optionsListWithAnswer } = this.props;

      let data = optionList;
      data.forEach(function (item: {
        isChecked: boolean;
        isDisabled: boolean;
        isMandatory: boolean;
        id: string;
      }) {
        if (item.id === "everyday-health") {
          item.isMandatory = true;
          // item.isChecked=true
        } else {
          item.isChecked = false;
          item.isDisabled = false;
        }
      });
      if (optionsListWithAnswer !== undefined) {
        data.forEach((element: any) => {
          if (
            _.find(optionsListWithAnswer, (obj) => obj.id === element?.id) !==
            undefined &&
            element?.id !== "everyday-health"
          ) {
            element.isChecked = true;
            // element.isDisabled=false
          } else {
            if (optionsListWithAnswer.length === 4) {
              element.isDisabled = true;
            }
          }
        });
        this.setState({
          listOfOptions: data,
          selectedValues: optionsListWithAnswer,
        });
      } else {
        this.setState({
          listOfOptions: data,
        });
      }
    }
  };

  handleCheckbox = (
    needStateValue: string,
    needStateId: string,
    index: number
  ) => {
    const { listOfOptions, selectedValues } = this.state;
    const {
      questionValue,
      questionTitle,
      questionType,
      optionsListWithAnswer,
    } = this.props;
    const data: any = listOfOptions;
    data[index].isChecked = !data[index].isChecked;

    /*Code for setting the priority of need states*/
    if (data && data[index].isChecked === true) {
      this.setState(
        {
          selectedValues: [
            ...this.state.selectedValues,
            { id: needStateId, value: needStateValue },
          ],
        },
        () => {
          /*code for setting null for remaining states if more than 1 need state is selected */
          let needStateValues: any = [...this.state.selectedValues];
          needStateValues = _.reject(
            needStateValues,
            ({ id, value }) => _.isNull(id) || _.isNull(value)
          );
          if (needStateValues.length > 0 && needStateValues.length < 3) {
            for (let i = needStateValues.length; i < 3; i++) {
              needStateValues.push({ id: null, value: null });
            }
          }
          this.setState({ selectedValues: needStateValues }, () => {
            let answersObj = [...needStateValues];

            answersObj = _.reject(
              needStateValues,
              ({ id, value }) => _.isNull(id) || _.isNull(value)
            );
            if (this.props.optionsListWithAnswer !== undefined) {
              _.remove(answersObj, (obj) => obj.id === "everyday-health");
              answersObj.push({
                id: "everyday-health",
                value: "Everyday Health",
              });
            } else {
              answersObj.push({
                id: "everyday-health",
                value: "Everyday Health",
              });
            }
            if (this.props.handleInputChange) {
              this.props.handleInputChange(
                questionType,
                questionValue,
                questionTitle,
                answersObj,
                true
              );
            }
          });
        }
      );
    } else {
      const selectedNeedStates = selectedValues;
      let indexOfItem = selectedNeedStates.findIndex(
        (i: any) => i.value === needStateValue
      );
      if (indexOfItem > -1) {
        selectedNeedStates.splice(indexOfItem, 1);
      }
      this.setState({ selectedValues: selectedNeedStates }, () => {
        let needStateValues: any = [...this.state.selectedValues];
        needStateValues = _.reject(
          needStateValues,
          ({ id, value }) => _.isNull(id) || _.isNull(value)
        );
        if (needStateValues.length > 0 && needStateValues.length < 3) {
          for (let i = needStateValues.length; i < 3; i++) {
            needStateValues.push({ id: null, value: null });
          }
        }
        this.setState({ selectedValues: needStateValues }, () => {
          let answersObj = [...needStateValues];
          answersObj = _.reject(
            needStateValues,
            ({ id, value }) => _.isNull(id) || _.isNull(value)
          );
          if (this.props.optionsListWithAnswer !== undefined) {
            _.remove(answersObj, (obj) => obj.id === "everyday-health");
            answersObj.push({
              id: "everyday-health",
              value: "Everyday Health",
            });
          } else {
            answersObj.push({
              id: "everyday-health",
              value: "Everyday Health",
            });
          }
          if (this.props.handleInputChange) {
            this.props.handleInputChange(
              questionType,
              questionValue,
              questionTitle,
              answersObj,
              true
            );
          }
        });
      });
    }
    const filteredOptionsLength = data.filter(
      (obj: any) => obj.isChecked === true
    ).length;

    /*Code for disabling the remaining options after 3 options are selected*/
    if (filteredOptionsLength === 3) {
      data &&
        data.forEach((element: any) => {
          if (element.isChecked === false) {
            element.isDisabled = true;
          }
        });
    } else {
      data &&
        data.forEach((element: any) => {
          element.isDisabled = false;
        });
    }
    this.setState({ listOfOptions: data });
  };

  render() {
    const { listOfOptions } = this.state;
    const { disableAllAnswers } = this.props;

    return (
      <div
        className={
          disableAllAnswers
            ? "answers-wrapper multiple-select-wrapper disabled "
            : "answers-wrapper multiple-select-wrapper"
        }
      >
        <div className="options-area">
          {listOfOptions &&
            listOfOptions.length > 0 &&
            listOfOptions.map((item: any, index: number) => (
              <div
                className={
                  item && item.isMandatory
                    ? "option mandatory"
                    : item && item.isDisabled
                      ? "option disable"
                      : "option"
                }
              >
                {/* <div className="radio-btn"> */}
                <CheckBox
                  className={
                    "checkbox"
                    // isError ? "checkbox checkbox-error" : "checkbox"
                  }
                  onCheckboxClick={() => {
                    this.handleCheckbox(item.value, item.id, index);
                  }}
                  isChecked={item && item.isChecked}
                />
                {/* </div> */}
                <div className="option-label" onClick={() => {
                  this.handleCheckbox(item.value, item.id, index);
                }}>{item && item.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default LongSuveryRankingComponent;
